// src/lib/http/errors.js
// Filepath: // src/lib/http/errors.js

export class ApiError extends Error {
  constructor(message, { status, url, body } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status ?? null;
    this.url = url ?? null;
    this.body = body ?? null;
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = "Unauthorized", extra) {
    super(message, extra);
    this.name = "UnauthorizedError";
  }
}

export class TimeoutError extends ApiError {
  constructor(message = "Request timed out", extra) {
    super(message, extra);
    this.name = "TimeoutError";
  }
}

export class NetworkError extends ApiError {
  constructor(message = "Network error", extra) {
    super(message, extra);
    this.name = "NetworkError";
  }
}
